import { useState } from 'react'

import Shared from '@/shared'

export interface PurchaseCarNumViewModel {
  texts: object
  states: {
    isStopModalOpen: boolean
  }
  setters: object
  handlers: {
    clickHeaderCloseBtn: () => void
    clickFooterContinueBtn: () => void
    handleCloseClick: () => void
  }
}

const usePurchaseHeaderViewModel = (): PurchaseCarNumViewModel => {
  const { setPurchaseStep } = Shared.States.usePurchaseStep()
  const { setIsPurchase } = Shared.States.useIsPurchase()
  const [isStopModalOpen, setIsStopModalOpen] = useState(false)

  const clickHeaderCloseBtn = () => {
    setIsStopModalOpen(true)
  }

  const clickFooterContinueBtn = () => {
    setIsStopModalOpen(false)
  }

  const handleCloseClick = () => {
    setPurchaseStep(0)
    setIsPurchase(false)
  }

  return {
    texts: {},
    states: {
      isStopModalOpen
    },
    setters: {},
    handlers: {
      clickHeaderCloseBtn,
      clickFooterContinueBtn,
      handleCloseClick
    }
  }
}

export default usePurchaseHeaderViewModel
